import classNames from "classnames";
import { CheckIcon, SpinnerIcon } from "@icons";
import type { AgentChatLiveResponseState } from "@api/agentChatStream.api";
import { AgentChatToolCallRow } from "./AgentChatToolCallRow";
import { formatMatchingLabel } from "./agentChatToolRow.helpers";
import styles from "./AgentChat.module.scss";

interface Props {
    liveResponse: AgentChatLiveResponseState;
}

// The in-flight assistant turn: a "matching available tools" step that spins
// while intent detection runs and flips to the detected tool(s) once resolved,
// followed by the live tool-call rows (sorted by traceIndex).
export const AgentChatLiveResponse: React.FC<Props> = ({ liveResponse }) => {
    const rows = [...liveResponse.rows.values()].sort(
        (a, b) => a.traceIndex - b.traceIndex,
    );
    const isMatched = liveResponse.intent !== null;

    return (
        <div className={styles.liveResponse}>
            <div className={styles.liveStep}>
                {isMatched ? (
                    <CheckIcon
                        className={classNames(
                            styles.toolCallIconDone,
                            "icon-color-green-600",
                        )}
                    />
                ) : (
                    <SpinnerIcon
                        className={classNames(
                            styles.toolCallSpinner,
                            "icon-color-gray-500",
                        )}
                    />
                )}
                <span className={styles.liveStepLabel}>
                    {formatMatchingLabel(liveResponse.intent)}
                </span>
            </div>
            {rows.map((row) => (
                <AgentChatToolCallRow key={row.traceIndex} row={row} />
            ))}
        </div>
    );
};
